import fetchWrapper from '../utils/FetchWrapper'
import { formatQueryString } from '../utils/FormatQueryString'

export function getAuthors (params) {
  return fetchWrapper(`curator`, `/authors${formatQueryString(params)}`)
}
